var map = {
	"./APU/0.jpg": 209,
	"./APU/1.jpg": 210,
	"./AU-UQ.jpg": 211,
	"./CYBERJAYA/0.jpg": 212,
	"./CYBERJAYA/1.jpg": 213,
	"./HK-HKSYU.jpg": 214,
	"./JAPAN-OsakaU.jpg": 215,
	"./JILONGPO/0.jpg": 216,
	"./JILONGPO/1.jpg": 217,
	"./JILONGPO/2.jpg": 218,
	"./JILONGPO/3.jpg": 219,
	"./JINYIN/0.jpg": 220,
	"./JINYIN/1.jpg": 221,
	"./JINYIN/2.jpg": 222,
	"./MASA/0.jpg": 223,
	"./MASA/1.jpg": 224,
	"./MASA/2.jpg": 225,
	"./MMU/0.jpg": 226,
	"./MMU/1.jpg": 227,
	"./MONASH/0.jpg": 228,
	"./MONASH/1.jpg": 229,
	"./MY-JILONGPO.jpg": 230,
	"./MY-JINYIN.jpg": 231,
	"./MY-MASA.jpg": 232,
	"./NEWERA/0.jpg": 233,
	"./NEWERA/1.jpg": 234,
	"./SING-Newcastle.jpg": 235,
	"./TAYLORS/0.jpg": 236,
	"./TAYLORS/1.jpg": 237,
	"./UA/0.jpg": 238,
	"./UA/1.jpg": 239,
	"./UAB/0.jpg": 240,
	"./UAB/1.jpg": 241,
	"./UAB/2.jpg": 242,
	"./UDG/0.jpg": 243,
	"./UDG/1.jpg": 244,
	"./UDG/2.jpg": 245,
	"./UDL/0.jpg": 246,
	"./UDL/1.jpg": 247,
	"./UDL/2.jpg": 248,
	"./UJI/0.jpg": 249,
	"./UJI/1.jpg": 250,
	"./UK-Lancaster.jpg": 251,
	"./UK-Sheffield.jpg": 252,
	"./UKM/0.jpg": 253,
	"./UKM/1.jpg": 254,
	"./UM/0.jpg": 255,
	"./UM/1.jpg": 256,
	"./UMH/0.jpg": 257,
	"./UMH/1.jpg": 258,
	"./UMS/0.jpg": 259,
	"./UMS/1.jpg": 260,
	"./UPC/0.jpg": 261,
	"./UPC/1.jpg": 262,
	"./UPC/2.jpg": 263,
	"./UPC/3.jpg": 264,
	"./UPF/0.jpg": 265,
	"./UPF/1.jpg": 266,
	"./UPM/0.jpg": 267,
	"./UPM/1.jpg": 268,
	"./UPV/0.jpg": 269,
	"./UPV/1.jpg": 270,
	"./UPV/2.jpg": 271,
	"./UPV/3.jpg": 272,
	"./URV/0.jpg": 273,
	"./URV/1.jpg": 274,
	"./URV/2.jpg": 275,
	"./URV/3.jpg": 276,
	"./USA-CWRU.jpg": 277,
	"./USA-California.jpg": 278,
	"./USA-California2.jpg": 279,
	"./USM/0.jpg": 280,
	"./USM/1.jpg": 281,
	"./UVIC/0.jpg": 282,
	"./UVIC/1.jpg": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;